import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import Hero from "./sections/Hero";
import OurServicesOverview from "./sections/OurServicesOverview";
import FeaturedCaseStudies from "./sections/FeaturedCaseStudies";
import MeetTheTeam from "./sections/MeetTheTeam";
import GetStartedCta from "./sections/GetStartedCta";
import Footer from "@/reusable_sections/Footer";
import WhyWorkWithUs from "./sections/WhyWorkWithUs";
export default function HomePage() {
  return <div>
      <Header />
      <Hero />
      <OurServicesOverview />
      <FeaturedCaseStudies />
      <MeetTheTeam />
      <WhyWorkWithUs />
      <GetStartedCta />
      <Footer />
    </div>;
}